import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.documentsToDelete = new Set();
    this.ensureButtonsCursorPointer();
  }

  ensureButtonsCursorPointer() {
    // Add cursor-pointer to all delete buttons on initial load
    const deleteButtons = this.element.querySelectorAll(
      '[data-action*="markForDeletion"]',
    );
    deleteButtons.forEach((button) => {
      button.classList.add("cursor-pointer");
    });
  }

  markForDeletion(event) {
    const documentId = event.currentTarget.dataset.documentId;
    const documentRow = event.currentTarget.closest("div[data-document-id]");

    if (this.documentsToDelete.has(documentId)) {
      // Unmark for deletion

      this.documentsToDelete.delete(documentId);
      this.unmarkDocumentVisually(documentRow, event.currentTarget);
      this.removeHiddenInput(documentId);
    } else {
      // Mark for deletion

      this.documentsToDelete.add(documentId);
      this.markDocumentVisually(documentRow, event.currentTarget);
      this.addHiddenInput(documentId);
    }
  }

  markDocumentVisually(documentRow, button) {
    // Mark document for deletion (keep original colors)

    // Change button text and style
    button.textContent = "Annuler suppression";
    button.classList.remove("text-red-500", "hover:text-red-700");
    button.classList.add(
      "text-green-500",
      "hover:text-green-700",
      "cursor-pointer",
    );

    // Find the filename span and apply line-through to it specifically
    const filenameSpan = documentRow.querySelector("span.flex-grow");
    if (filenameSpan) {
      filenameSpan.classList.add("line-through");
    }

    // Add a deletion indicator outside the filename span to avoid line-through
    const indicator = document.createElement("span");
    indicator.textContent = " (À supprimer)";
    indicator.classList.add("text-red-500", "text-xs", "italic");
    indicator.dataset.deletionIndicator = "true";

    if (filenameSpan && filenameSpan.parentNode) {
      filenameSpan.parentNode.insertBefore(indicator, filenameSpan.nextSibling);
    }
  }

  unmarkDocumentVisually(documentRow, button) {
    // Remove visual indicators

    // Reset button text and style
    button.textContent = "Supprimer";
    button.classList.remove("text-green-500", "hover:text-green-700");
    button.classList.add(
      "text-red-500",
      "hover:text-red-700",
      "cursor-pointer",
    );

    // Remove line-through from filename span
    const filenameSpan = documentRow.querySelector("span.flex-grow");
    if (filenameSpan) {
      filenameSpan.classList.remove("line-through");
    }

    // Remove deletion indicator
    const indicator = documentRow.querySelector("[data-deletion-indicator]");
    if (indicator) {
      indicator.remove();
    }
  }

  addHiddenInput(documentId) {
    const hiddenInput = document.createElement("input");
    hiddenInput.type = "hidden";
    hiddenInput.name = "organization_annual_report[documents_to_delete][]";
    hiddenInput.value = documentId;
    hiddenInput.dataset.documentId = documentId;

    const container = this.element.querySelector(
      '[data-document-manager-target="deletionContainer"]',
    );
    if (container) {
      container.appendChild(hiddenInput);
    }
  }

  removeHiddenInput(documentId) {
    const container = this.element.querySelector(
      '[data-document-manager-target="deletionContainer"]',
    );
    const hiddenInput = container
      ? container.querySelector(`input[data-document-id="${documentId}"]`)
      : null;
    if (hiddenInput) {
      hiddenInput.remove();
    }
  }
}
